<template>
  <div class="order-query-page">
    <!-- 头部 -->
    <div class="page-header">
      <h1 class="page-title">订单查询</h1>
    </div>

    <!-- Tab 切换 -->
    <div class="tab-container">
      <div 
        class="tab-item" 
        :class="{ active: activeTab === 'bd' }"
        :style="activeTab === 'bd' ? { color: themeColor } : {}"
        @click="switchTab('bd')">
        抖音高佣
      </div>
      <div 
        class="tab-item" 
        :class="{ active: activeTab === 'sup' }"
        :style="activeTab === 'sup' ? { color: themeColor } : {}"
        @click="switchTab('sup')">
        独家爆品
      </div>
    </div>

    <!-- 查询方式切换 -->
    <div class="query-type-tabs">
      <div 
        class="query-type-item"
        :class="{ active: queryType === 'manual' }"
        :style="queryType === 'manual' ? { background: themeColor, color: '#fff' } : {}"
        @click="queryType = 'manual'">
        手动查询
      </div>
      <div 
        class="query-type-item"
        :class="{ active: queryType === 'file' }"
        :style="queryType === 'file' ? { background: themeColor, color: '#fff' } : {}"
        @click="queryType = 'file'">
        批量查询
      </div>
    </div>

    <!-- 手动查询 -->
    <div v-if="queryType === 'manual'" class="query-section">
      <div class="input-label">订单编号</div>
      <!-- 
        maxlength="10000" -->
      <el-input
        type="textarea"
        v-model="orderSnInput"
        placeholder="请输入订单编号，每行一个，每个订单编号19位数字"
        :rows="5"
        show-word-limit
        @input="validateOrderSnInput">
      </el-input>
      <div class="input-tip">每行只能输入19位数字，多条订单请换行输入</div>
    </div>

    <!-- 文件查询 -->
    <div v-else class="query-section">
      <div class="template-link">
        <div @click="downloadTemp" :style="{ color: themeColor }">下载模板</div>
      </div>
      <div 
        class="upload-area" 
        :class="{ 'is-dragover': isDragover }"
        @click="triggerFileUpload" 
        @drop.prevent="handleDrop"
        @dragover.prevent="handleDragover"
        @dragleave.prevent="handleDragleave"
        :style="{ borderColor: isDragover ? themeColor : '#ddd' }">
        <i class="el-icon-upload" :style="{ color: themeColor }"></i>
        <div class="upload-text">点击或拖拽文件到此处上传</div>
        <div class="upload-tip">请先下载导入模版，填入数据后，再进行订单上传 <br>数量1，大小2M以内，支持格式xls,xlsx</div>
        <input 
          ref="fileInput" 
          type="file" 
          accept=".xlsx,.xls" 
          style="display: none"
          @change="handleFileChange">
      </div>
      <div v-if="uploadedFile" class="uploaded-file">
        <i class="el-icon-document" :style="{ color: themeColor }"></i>
        <span>{{ uploadedFile.name }}</span>
        <i class="el-icon-close" @click="removeFile"></i>
      </div>
    </div>

    <!-- 查询按钮 -->
    <el-button 
      type="primary" 
      class="query-btn" 
      :loading="loading"
      :style="{ background: themeColor, borderColor: themeColor }"
      @click="handleQuery">
      订单查询
    </el-button>

    <!-- 状态筛选 -->
    <div v-if="orderList.length > 0" class="status-filter">
      <div 
        class="status-item"
        :class="{ active: filterStatus === null }"
        :style="filterStatus === null ? { background: themeColor, color: '#fff' } : {}"
        @click="filterStatus = null">
        全部
      </div>
      <!-- 抖音高佣只显示：全部/已跟单/已丢单 -->
      <template v-if="activeTab === 'bd'">
        <div 
          class="status-item"
          :class="{ active: filterStatus === 1 }"
          :style="filterStatus === 1 ? { background: themeColor, color: '#fff' } : {}"
          @click="filterStatus = 1">
          已跟单
        </div>
        <div 
          class="status-item"
          :class="{ active: filterStatus === 2 }"
          :style="filterStatus === 2 ? { background: themeColor, color: '#fff' } : {}"
          @click="filterStatus = 2">
          已丢单
        </div>
      </template>
      <!-- 独家爆品显示所有状态 -->
      <template v-else>
        <div 
          class="status-item"
          :class="{ active: filterStatus === 0 }"
          :style="filterStatus === 0 ? { background: themeColor, color: '#fff' } : {}"
          @click="filterStatus = 0">
          查询中
        </div>
        <div 
          class="status-item"
          :class="{ active: filterStatus === 1 }"
          :style="filterStatus === 1 ? { background: themeColor, color: '#fff' } : {}"
          @click="filterStatus = 1">
          已跟单
        </div>
        <div 
          class="status-item"
          :class="{ active: filterStatus === 2 }"
          :style="filterStatus === 2 ? { background: themeColor, color: '#fff' } : {}"
          @click="filterStatus = 2">
          已丢单
        </div>
        <div 
          class="status-item"
          :class="{ active: filterStatus === 3 }"
          :style="filterStatus === 3 ? { background: themeColor, color: '#fff' } : {}"
          @click="filterStatus = 3">
          复核中
        </div>
      </template>
    </div>

    <!-- 订单列表 -->
    <div class="order-list">
      <div 
        v-for="order in filteredOrderList" 
        :key="order.thirdOrderSn"
        class="order-card">
        <!-- 订单编号、复制按钮和状态标签 -->
        <div class="order-header">
          <div class="order-header-left">
            <span class="order-sn">订单编号：{{ order.thirdOrderSn }}</span>
            <el-button 
              type="text" 
              size="small"
              class="copy-btn"
              :style="{ color: themeColor }"
              @click="copyOrderSn(order.thirdOrderSn)">
              <!-- <i class="el-icon-document-copy"></i> -->
              复制
            </el-button>
          </div>
          <div class="order-status" :class="getStatusClass(order.reportStatus)">
            {{ getStatusText(order.reportStatus) }}
          </div>
        </div>

        <!-- 订单信息 -->
        <div v-if="order.goodsName || order.goodsThumbnailUrl || order.orderAmount" class="order-content">
          <div class="order-image">
            <img :src="order.goodsThumbnailUrl || defaultImage" alt="商品图片">
          </div>
          <div class="order-info">
            <div class="goods-name">{{ order.goodsName || '-' }}</div>
            <div class="order-amount">¥ {{ order.orderAmount || '0.00' }}</div>
          </div>
        </div>

        <!-- 抖音高佣：支付时间 + 小程序链接 -->
        <template v-if="order.reportStatus !== null && activeTab === 'bd'">
          <div class="order-extra">
            <span class="extra-label">支付时间：</span>
            <span class="extra-value">{{ formatTime(order.payTime) }}</span>
          </div>
          <div class="order-extra">
            <span class="extra-label">小程序链接：</span>
            <a v-if="order.wechatMiniAppLink" :href="order.wechatMiniAppLink" target="_blank" class="extra-link" :style="{ color: themeColor }">{{ order.wechatMiniAppLink }}</a>
            <span v-else class="extra-value">-</span>
          </div>
        </template>

        <!-- 独家爆品：报单时间 + 订单件数 -->
        <template v-if="order.reportStatus !== null && activeTab === 'sup'">
          <div class="order-extra">
            <span class="extra-label">报单时间：</span>
            <span class="extra-value">{{ formatTime(order.reportTime) }}</span>
          </div>
          <div class="order-extra">
            <span class="extra-label">订单件数：</span>
            <!-- 订单件数字段：待后端确认字段名，暂用 itemCount -->
            <span class="extra-value">{{ order.itemCount != null ? order.itemCount : '-' }}</span>
          </div>
        </template>

        <!-- 未查询到数据的提示（仅在查询完成后显示） -->
        <div v-if="order.reportStatus === null && !loading" class="no-data-tip">
          未查询到该订单信息
        </div>
      </div>

      <!-- 未查询到订单提示 -->
      <div v-if="hasQueried && orderList.length === 0" class="empty-result">
        <i class="el-icon-warning-outline"></i>
        <div>未查询到订单信息</div>
      </div>
    </div>

    <!-- 按钮提示弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="showTipDialog"
      width="80%"
      center>
      <div class="tip-content">
        尊敬的用户你好，请输入或上传订单编码，然后在进行查询
      </div>
      <span slot="footer">
        <el-button 
          type="primary" 
          :style="{ background: themeColor, borderColor: themeColor }"
          @click="showTipDialog = false">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { 
  queryBdOrderBySnList, 
  queryBdOrderByFile,
  querySupOrderBySnList,
  querySupOrderByFile
} from '@/service/apis/order'
import defaultImage from '@/assets/images/default.png'

export default {
  name: 'OrderQuery',
  data() {
    return {
      activeTab: 'bd', // bd: 抖音高佣, sup: 独家爆品
      queryType: 'manual', // manual: 手动查询, file: 文件查询
      orderSnInput: '', // 手动输入的订单编号
      uploadedFile: null, // 上传的文件
      loading: false,
      orderList: [], // 查询结果
      filterStatus: null, // 状态筛选
      hasQueried: false, // 是否已查询过
      showTipDialog: false, // 显示提示弹框
      isDragover: false, // 是否正在拖拽
      defaultImage
    }
  },
  mounted() {
    // H5 页面需要覆盖后台全局样式中的 overflow: hidden
    document.documentElement.style.setProperty('overflow', 'auto', 'important')
    document.documentElement.style.setProperty('height', 'auto', 'important')
    document.body.style.setProperty('overflow', 'auto', 'important')
    document.body.style.setProperty('height', 'auto', 'important')
  },
  beforeDestroy() {
    // 离开页面时还原全局样式
    document.documentElement.style.removeProperty('overflow')
    document.documentElement.style.removeProperty('height')
    document.body.style.removeProperty('overflow')
    document.body.style.removeProperty('height')
  },
  computed: {
    // 过滤后的订单列表
    filteredOrderList() {
      if (this.filterStatus === null) {
        return this.orderList
      }
      return this.orderList.filter(order => order.reportStatus === this.filterStatus)
    },
    // 主题颜色
    themeColor() {
      return this.activeTab === 'bd' ? '#ff6677' : '#ed58ce'
    }
  },
  methods: {
    downloadTemp () {
      window.open(location.origin + '/template/OrderQueryTemplate.xlsx')
    },
    // 切换 Tab
    switchTab(tab) {
      this.activeTab = tab
      this.resetQuery()
    },

    // 重置查询
    resetQuery() {
      this.orderSnInput = ''
      this.uploadedFile = null
      this.orderList = []
      this.filterStatus = null
      this.hasQueried = false
    },

    // 验证订单编号输入
    validateOrderSnInput(value) {
      // 每行只能输入19位数字
      const lines = value.split('\n')
      const validLines = lines.map(line => {
        // 只保留数字
        const numbers = line.replace(/\D/g, '')
        // 限制19位
        return numbers.slice(0, 19)
      })
      this.orderSnInput = validLines.join('\n')
    },

    // 触发文件上传
    triggerFileUpload() {
      this.$refs.fileInput.click()
    },

    // 处理文件选择
    handleFileChange(e) {
      const file = e.target.files[0]
      if (file) {
        this.validateAndSetFile(file)
      }
    },

    // 验证并设置文件
    validateAndSetFile(file) {
      // 验证文件数量（只允许上传1个文件）
      if (this.uploadedFile) {
        this.$message.warning('只能上传1个文件，请先删除已上传的文件')
        return false
      }

      // 验证文件类型
      const fileName = file.name
      const fileExt = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
      if (fileExt !== '.xlsx' && fileExt !== '.xls') {
        this.$message.error('仅支持 xls 或 xlsx 格式文件')
        return false
      }

      // 验证文件大小（2M = 2 * 1024 * 1024 bytes）
      const maxSize = 2 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过 2M')
        return false
      }

      this.uploadedFile = file
      return true
    },

    // 处理拖拽进入
    handleDragover(e) {
      this.isDragover = true
    },

    // 处理拖拽离开
    handleDragleave(e) {
      this.isDragover = false
    },

    // 处理文件拖放
    handleDrop(e) {
      this.isDragover = false
      const files = e.dataTransfer.files
      if (files.length > 0) {
        this.validateAndSetFile(files[0])
      }
    },

    // 移除文件
    removeFile() {
      this.uploadedFile = null
      this.$refs.fileInput.value = ''
    },

    // 查询订单
    async handleQuery() {
      // 验证输入
      if (this.queryType === 'manual') {
        if (!this.orderSnInput.trim()) {
          this.showTipDialog = true
          return
        }
      } else {
        if (!this.uploadedFile) {
          this.showTipDialog = true
          return
        }
      }

      this.loading = true
      this.hasQueried = true

      try {
        let result
        if (this.queryType === 'manual') {
          // 手动查询
          const orderSnList = this.orderSnInput
            .split('\n')
            .map(sn => sn.trim())
            .filter(sn => sn.length > 0)

          const params = {
            thirdOrderSnList: orderSnList
          }

          if (this.activeTab === 'bd') {
            result = await queryBdOrderBySnList.call(this, params)
          } else {
            result = await querySupOrderBySnList.call(this, params)
          }
        } else {
          // 文件查询
          if (this.activeTab === 'bd') {
            result = await queryBdOrderByFile.call(this, this.uploadedFile)
          } else {
            result = await querySupOrderByFile.call(this, this.uploadedFile)
          }
        }
        console.log('orderList:', result)
        if (result && result.orderList) {
          this.orderList = result.orderList
          // 处理"报单状态更新存在延迟"的情况，归类为查询中
          this.orderList.forEach(order => {
            if (order.reportStatus === null || order.reportStatus === undefined) {
              order.reportStatus = 2 // 未查询到的归类为已丢单
            }
          })
        } else {
          this.orderList = []
        }
      } catch (error) {
        console.error('查询失败', error)
        this.$message.error('查询失败，请稍后重试')
        this.orderList = []
      } finally {
        this.loading = false
      }
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        bd: {
          0: '查询中',
          1: '已跟单',
          2: '已丢单',
          3: '已返款'
        },
        sup: {
          0: '查询中',
          1: '已跟单',
          2: '已丢单',
          3: '复核中'
        }
      }
      return statusMap[this.activeTab][status] || '未知状态'
    },

    // 获取状态样式类
    getStatusClass(status) {
      const classMap = {
        0: 'status-querying',
        1: 'status-followed',
        2: 'status-lost',
        3: 'status-refunded'
      }
      return classMap[status] || ''
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return '-'
      const date = new Date(time)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hour = String(date.getHours()).padStart(2, '0')
      const minute = String(date.getMinutes()).padStart(2, '0')
      const second = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },

    // 复制订单编号（兼容移动端）
    copyOrderSn(sn) {
      // 优先使用现代 Clipboard API
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(sn).then(() => {
          this.$message.success('复制成功')
        }).catch(() => {
          // 降级到传统方法
          this.fallbackCopy(sn)
        })
      } else {
        // 降级到传统方法
        this.fallbackCopy(sn)
      }
    },

    // 降级复制方法
    fallbackCopy(text) {
      const input = document.createElement('input')
      input.value = text
      input.style.position = 'fixed'
      input.style.top = '0'
      input.style.left = '-9999px'
      document.body.appendChild(input)
      
      // iOS 兼容性处理
      if (navigator.userAgent.match(/ipad|iphone/i)) {
        input.contentEditable = true
        input.readOnly = false
        const range = document.createRange()
        range.selectNodeContents(input)
        const selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
        input.setSelectionRange(0, 999999)
      } else {
        input.select()
      }
      
      try {
        document.execCommand('copy')
        this.$message.success('复制成功')
      } catch (err) {
        this.$message.error('复制失败，请手动复制')
      }
      
      document.body.removeChild(input)
    }
  }
}
</script>

<style scoped>
.order-query-page {
  max-width: 640px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 20px;
  /* 防止移动端缩放 */
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
}

.page-header {
  background: #fff;
  padding: 16px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  /* 防止点击高亮 */
  -webkit-tap-highlight-color: transparent;
}

.page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

.tab-container {
  display: flex;
  background: #fff;
  margin-top: 10px;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 14px 0;
  font-size: 15px;
  color: #666;
  cursor: pointer;
  position: relative;
  /* 防止点击高亮 */
  -webkit-tap-highlight-color: transparent;
  /* 防止长按选中 */
  -webkit-user-select: none;
  user-select: none;
}

.tab-item.active {
  font-weight: 500;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: currentColor;
  border-radius: 2px;
}

.query-type-tabs {
  display: flex;
  background: #fff;
  margin: 10px 16px;
  border-radius: 4px;
  overflow: hidden;
}

.query-type-item {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
  color: #666;
  background: #fff;
  cursor: pointer;
  /* 防止点击高亮 */
  -webkit-tap-highlight-color: transparent;
  /* 防止长按选中 */
  -webkit-user-select: none;
  user-select: none;
}

.query-type-item.active {
  /* 颜色通过内联样式动态设置 */
}

.query-section {
  margin: 16px;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
}

.input-label {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  font-weight: 500;
}

.input-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.upload-area {
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  /* 防止点击高亮 */
  -webkit-tap-highlight-color: transparent;
}

.upload-area:hover {
  border-color: currentColor;
}

.upload-area.is-dragover {
  background: rgba(79, 138, 255, 0.05);
  transform: scale(1.02);
}

.upload-area.is-dragover::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 8px;
  pointer-events: none;
}

.upload-area .el-icon-upload {
  font-size: 48px;
  /* 颜色通过内联样式动态设置 */
}

.upload-area .upload-text {
  font-size: 16px;
  color: #333;
  margin-top: 12px;
}

.upload-area .upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  line-height: 20px;
}

.uploaded-file {
  display: flex;
  align-items: center;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 4px;
  margin-top: 12px;
}

.uploaded-file .el-icon-document {
  font-size: 20px;
  /* 颜色通过内联样式动态设置 */
  margin-right: 8px;
}

.uploaded-file span {
  flex: 1;
  font-size: 14px;
  color: #333;
  /* 防止长文件名溢出 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.uploaded-file .el-icon-close {
  font-size: 16px;
  color: #999;
  cursor: pointer;
  /* 增大点击区域 */
  padding: 4px;
  margin: -4px;
}

.uploaded-file .el-icon-close:hover {
  color: #333;
}

.template-link {
  margin-bottom: 12px;
  cursor: pointer;
  /* 防止点击高亮 */
  -webkit-tap-highlight-color: transparent;
}

.template-link div {
  display: inline-block;
  text-decoration: underline;
}

.query-btn {
  width: calc(100% - 32px);
  margin: 0 16px;
  height: 44px;
  font-size: 16px;
  border-radius: 6px;
  /* 防止点击高亮 */
  -webkit-tap-highlight-color: transparent;
}

.status-filter {
  display: flex;
  margin: 16px;
  background: #fff;
  border-radius: 8px;
  padding: 8px;
  overflow-x: auto;
  /* 隐藏滚动条但保持滚动功能 */
  -webkit-overflow-scrolling: touch;
}

.status-filter::-webkit-scrollbar {
  display: none;
}

.status-item {
  flex-shrink: 0;
  padding: 8px 16px;
  font-size: 14px;
  color: #666;
  background: #f5f5f5;
  border-radius: 16px;
  margin-right: 8px;
  cursor: pointer;
  white-space: nowrap;
  /* 防止点击高亮 */
  -webkit-tap-highlight-color: transparent;
  /* 防止长按选中 */
  -webkit-user-select: none;
  user-select: none;
}

.status-item:last-child {
  margin-right: 0;
}

.status-item.active {
  /* 颜色通过内联样式动态设置 */
}

.order-list {
  margin: 0 16px;
}

.order-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.order-header-left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  margin-right: 8px;
}

.order-sn {
  font-size: 12px;
  color: #333;
  font-weight: 500;
  /* 订单编号可能很长，允许换行 */
  word-break: break-all;
}

.copy-btn {
  padding: 0;
  /* 颜色通过内联样式动态设置 */
  flex-shrink: 0;
  /* 增大点击区域 */
  padding: 4px 8px;
  margin-left: 4px;
  /* 防止点击高亮 */
  -webkit-tap-highlight-color: transparent;
}

.order-status {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  flex-shrink: 0;
}

.order-status.status-querying {
  background: #FFF7E6;
  color: #FA8C16;
}

.order-status.status-followed {
  background: #E6F7FF;
  color: #1890FF;
}

.order-status.status-lost {
  background: #FFF1F0;
  color: #F5222D;
}

.order-status.status-refunded {
  background: #F6FFED;
  color: #52C41A;
}

.order-content {
  display: flex;
}

.order-image {
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  margin-right: 12px;
}

.order-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  /* 防止图片拖拽 */
  -webkit-user-drag: none;
  user-select: none;
}

.order-info {
  flex: 1;
  min-width: 0;
}

.goods-name {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  /* 防止长按选中 */
  -webkit-user-select: text;
  user-select: text;
}

.order-amount {
  font-size: 16px;
  color: #F5222D;
  font-weight: 500;
  margin-bottom: 8px;
}

.order-time {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}

.order-extra {
  display: flex;
  align-items: flex-start;
  font-size: 12px;
  color: #999;
  line-height: 1.8;
  margin-top: 6px;
}

.extra-label {
  flex-shrink: 0;
  color: #999;
}

.extra-value {
  color: #666;
  word-break: break-all;
}

.extra-link {
  font-size: 12px;
  text-decoration: none;
  word-break: break-all;
  -webkit-tap-highlight-color: transparent;
}

.extra-link:hover {
  text-decoration: underline;
}

.no-data-tip {
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 14px;
}

.empty-result {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

.empty-result .el-icon-warning-outline {
  font-size: 48px;
  margin-bottom: 12px;
}

.empty-result div {
  font-size: 14px;
}

.tip-content {
  text-align: center;
  padding: 20px;
  font-size: 15px;
  color: #333;
  line-height: 1.6;
}

/* 移动端适配 */
@media screen and (max-width: 375px) {
  .order-sn {
    font-size: 13px;
  }
  
  .copy-btn {
    font-size: 12px;
  }
  
  .order-status {
    font-size: 11px;
    padding: 3px 10px;
  }
}
</style>

<!-- 覆盖全局 reset.css 中 html/body 的 overflow: hidden，仅在查单页面生效 -->
<style>
.order-query-page ~ * {}
html:has(.order-query-page),
body:has(.order-query-page) {
  overflow: auto !important;
  height: auto !important;
}
</style>
